<template>
  <Card class="layout-card">
    <div style="margin-bottom: 10px;">
      <div class="search-form">
        <Select v-model="searchForm.metric" multiple placeholder="请选择字段" :max-tag-count="1" @on-change="changeMetric"
          label-in-value filterable>
          <template #prefix>
            <a style="font-size: 12px;padding: 0 5px;white-space: nowrap;" @click="(e) => {
              e.preventDefault()
              e.stopPropagation();
              if (metric.length === playData.length) {
                searchForm.metric = []
                changeMetric([])
              }
              else {
                const data = playData.map(i => i.value)
                searchForm.metric = data
                changeMetric(playData)
              }

            }">{{ metric.length === playData.length ? '清空' : '全选' }}</a>
          </template>
          <Option v-for="(i, index) in playData" :key="index" :value="i.value">{{ i.label }}</Option>
        </Select>
        <Select v-model="searchForm.langId" placeholder="请选择语言" style="width: 150px;" clearable>
          <Option v-for="(item, index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
        </Select>
        <Select placeholder="渠道" clearable v-model="searchForm.channel" style="width: 120px">
          <Option :value="0">facebook</Option>
          <Option :value="1">tiktok</Option>
          <Option :value="2">google</Option>
        </Select>
        <div>
          <Select placeholder="维度" style="width: 70px" v-model="searchForm.aggregateDimension">
            <Option :value="1">日</Option>
            <Option :value="2">周</Option>
            <Option :value="3">月</Option>
          </Select>
          <DatePicker :editable="false" format="yyyy-MM-dd" type="daterange" style="width: 200px" placeholder="请选择日期" :value="listDate"
            @on-change="getListDate" clearable></DatePicker>
        </div>

        <Input v-model="searchForm.playCnName" placeholder="请输入短剧名称" style="width: 200px" />
        <!-- <Input v-model="searchForm.playCnName" placeholder="请输入中文剧名" style="width: 200px"  /> -->
        <Input type="number" placeholder="请输入短剧ID" v-model="searchForm.playId" :precision="0" style="width: 120px" />
        <Select v-model="searchForm.timeZone" placeholder="请选择时区" style="width: 100px">
          <!-- <Option :value="8">东八区</Option> -->
          <Option :value="-8">西八区</Option>
        </Select>
        <Button type="primary" @click="getData()">查询</Button>
        <Button style="width: auto;" @click="handleReset()">重置</Button>
        <Button style="width: auto;" type="warning" @click="handleExport()">导出</Button>
      </div>
    </div>
    <div>
      <Table border :data="tableData" :columns="column" v-if="columns.length > 1" :loading="showTable"
        @on-sort-change="test" show-summary :summary-method="handleSummary">
        <Pages slot="footer" :page="page" :func="getData" :pArr="[31, 50]"></Pages>
      </Table>
      <div v-else style="text-align: center;font-size: 18px;padding: 20px 0">请选择查询项</div>
    </div>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import { gePlayDataColorNew as getPlayData } from '@/api/data'
import { utils, writeFile } from 'xlsx'
import { getLangList } from '../../api/lang'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { playData } from '.'
export default {
  name: 'playDataColorNew',
  components: {
    Pages
  },
  data() {
    return {
      playData,
      editVisible: false,
      form: {},
      searchForm: {
        metric: [],
        playId: '',
        aggregateDimension: 1,
        timeZone: -8
      },
      orders: {
        key: '',
        order: ''
      },
      listDate: [],
      submitLoading: false,
      showTable: false,
      page: {
        current: 1,
        size: 31,
        total: 0
      },
      langList: [],
      metric: [],
      tableData: [],
      column: [],
      realData: [],
      campaign: [],
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('playData')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    },
    columns() {
      const res = this.metric.map(i => {
        return {
          title: i.label,
          needCalc: i.needCalc,
          calc: i.calc,
          nosum: i.nosum,
          resizable: true,
          key: i.value.split(',')[1],
          width: i.width ? i.width : (i.label.length > 7 ? 140 : 110),
          sortable: i.sortable,
          tooltip: i.tooltip,
          render: i.render
        }

      })
      return [...res]
    }
  },
  methods: {
    test({ column, key, order }) {

      this.orders = {
        key,
        order
      }
      this.getData()
    },
    handleExport() {
      const headerRow = this.column.map(header => header.title);
      getPlayData({
        ...this.searchForm,
        current: 1,
        size: 50000,
        metric: this.searchForm.metric.map(i => i.split(',')[0]).join(','),
      }).then(r => {
        const dataRows = r.data.pageData.records.map(item => {
          return this.column.map(header => {
            // 处理嵌套属性（如：'user.address.city'）
            const prop = header.key;
            if (header.key == 'channel') {
              return ['facebook', 'tiktok', 'google'][item[prop]]
            }
            return item[prop] ? (header.render ? Number(item[prop] * 100).toFixed(2) + '%' : item[prop]) : 0; // 空值处理
          });
        });
        const worksheetData = [
          headerRow,
          ...dataRows
        ];
        const worksheet = utils.aoa_to_sheet(worksheetData);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "短剧数据");

        // 6. 生成Excel文件并下载
        writeFile(workbook, "短剧数据.xlsx");
      })
    },
    handleSummary({ columns, data }) {

      const res = {}
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (!index) {
          sums[key] = {
            key,
            value: '合计'
          }
          return
        }
        sums[key] = {
          key,
          value: column.needCalc ? ((this.sums[key] * 100).toFixed(2) + '%' || '-') : this.sums[key]
        }
      })

      return sums

    },
    changeMetric(e) {
      const values = e.map(i => i.value)
      localStorage.setItem('play-metric-color', JSON.stringify(values))
      this.metric = playData.filter(i => values.indexOf(i.value) > -1)
    },
    getListDate(data) {
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.showTable = true
      this.column = this.columns
      getPlayData({
        ...this.searchForm,
        ...this.page,
        orderStr: this.orders.order&&this.orders.order != 'normal' ? this.orders.key + ' ' + this.orders.order : '',
        metric: this.searchForm.metric.map(i => i.split(',')[0]).join(','),
      }).then(({ data }) => {
        const { pageData, total } = data
        this.tableData = pageData.records
        this.page.total = pageData.total
        this.showTable = false
        this.sums = total
      })
    },
    // getTable(page) {
    //   if (page) this.page.current = page
    //   else this.page.current = 1
    //   const tb = cloneDeep(this.realData)
    //   if (this.orders.order && this.orders.order != 'normal') {
    //     if (this.orders.order == 'asc') {
    //       tb.sort((a, b) => {
    //         if (typeof a[this.orders.key] == 'string')
    //           return a[this.orders.key].localeCompare(b[this.orders.key], 'zh-Hans-CN')
    //         else return a[this.orders.key] - b[this.orders.key]
    //       })
    //     } else {
    //       tb.sort((a, b) => {
    //         if (typeof a[this.orders.key] == 'string')
    //           return b[this.orders.key].localeCompare(a[this.orders.key], 'zh-Hans-CN')
    //         else return b[this.orders.key] - a[this.orders.key]
    //       })
    //     }
    //   }
    //   this.tableData = tb.slice((this.page.current - 1) * this.page.size, this.page.current * this.page.size)
    // },
    handleReset() {
      this.searchForm = {
        metric: playData.filter(i => !i.disabled).map(i => i.value),
        startDate: dayjs().format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        playId: '',
        aggregateDimension: 1,
        channel: '',
        timeZone: -8
      }
      this.getListDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
      this.changeMetric(playData.filter(i => !i.disabled))
    },
    handleGetLang() {
      getLangList({ current: -1, size: -1, langStatus: true }).then(r => {
        this.langList = r.data.records
      })
    },
  },
  mounted() {
    const metric = localStorage.getItem('play-metric-color')
    this.handleGetLang()
    if (!metric) {
      this.searchForm.metric = playData.filter(i => !i.disabled).map(i => i.value)
      this.changeMetric(playData.filter(i => !i.disabled))
    } else {
      this.searchForm.metric = JSON.parse(metric)
      this.metric = playData.filter(i => JSON.parse(metric).indexOf(i.value) > -1)

    }

    this.column = this.columns
    this.getListDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;

  flex-wrap: wrap;

  &>* {
    margin: 0 5px 10px;
    max-width: 300px;
  }
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

/deep/.ivu-table td,
.ivu-table th {
  height: 20px;
}

/deep/.ivu-table {
  .ivu-table-tbody {
    .ivu-table-row:last-child {
      height: 30px;

      td {
        vertical-align: top;
        height: 30px;
      }
    }

  }
}
</style>
